import composer, { type optionPairType } from "./composer";

export default (option: optionPairType) =>
  composer(option, "textInput", {
    fieldLabel:
      "Base URL (`hcm` will be resolved as hcm/{{objectName}}/{{recordId}}/print)",
    fieldValue: "",
  });
